module.exports = __webpack_public_path__ + "static/media/volunteer.5287afbf.svg";